export default function parsePlace(place) {
  place = place || {};

  const byType = (place.address_components || []).reduce((acc, data) => {
    data.types.forEach(function (type) {
      acc[type] = data;
    });
    return acc;
  }, {});

  const placeGet = (key, short) => {
    if (!(key in byType)) return '';

    return short ? byType[key].short_name : byType[key].long_name;
  };

  // see https://developers.google.com/maps/documentation/geocoding/requests-geocoding#Types
  // notably, "Do not parse the formatted address programmatically."
  const result = {
    streetNumber: placeGet('street_number') || placeGet('street_address'),
    streetName: placeGet('route'),
    city: placeGet('postal_town') ||
      placeGet('locality') ||
      placeGet('sublocality') ||
      placeGet('sublocality_level_1') ||
      placeGet('administrative_area_level_3') ||
      placeGet('administrative_area_level_2'),
    county: placeGet('administrative_area_level_2'),
    stateShort: placeGet('administrative_area_level_1', true),
    stateLong: placeGet('administrative_area_level_1'),
    countryShort: placeGet('country', true),
    countryLong: placeGet('country'),
    zipCode: placeGet('postal_code')
  };

  result.address = `${result.streetNumber} ${result.streetName}`;

  return result;
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/parseGooglePlace.js